import { Button, Col, Form, Input, Row, notification } from "antd";
import React, { useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";

const NewSupplier = ({ history }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const createSupplier = async (data) => {
		const supplier = {
			name: data.name,
		};

		try {
			const url = api + "/supplier/create";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, supplier);
			if (data.success) {
				openNotification("success", "Success", "Supplier created");
				setTimeout(() => {
					setLoading(false);
					history.push("/supplier/list");
				}, 2000);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to create supplier"
			);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		createSupplier(values);
	};

	const CustomForm = () => {
		return (
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>

				<Button type="primary" htmlType="submit" loading={loading} size="large">
					Create
				</Button>
			</Form>
		);
	};

	return (
		<Layout
			title="New Supplier"
			description="Create new Supplier"
			type="medium"
		>
			<CustomForm />
			{contextHolder}
		</Layout>
	);
};

export default NewSupplier;
